module.exports = __webpack_public_path__ + "static/media/loginRegister.88644e13.jpg";